"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderNames = void 0;
var FolderNames = /** @class */ (function () {
    function FolderNames() {
    }
    FolderNames.isValidFolderName = function (folderName) {
        return Object.values(FolderNames).includes(folderName);
    };
    FolderNames.actions = "Actions";
    FolderNames.additionalFields = "AdditionalFields";
    FolderNames.bonuses = "Bonuses";
    FolderNames.calendar = "Calendar";
    FolderNames.capacityNotes = "CapacityNotes";
    FolderNames.capacityNoteTypes = "CapacityNoteTypes";
    FolderNames.carts = "Carts";
    FolderNames.columnPermissions = "ColumnPermissions";
    FolderNames.companies = "Companies";
    FolderNames.contacts = "Contacts";
    FolderNames.currencyExchangeRates = "CurrencyExchangeRates";
    FolderNames.documents = "Documents";
    FolderNames.emails = "Emails";
    FolderNames.enumTypes = "EnumTypes";
    FolderNames.enumValues = "EnumValues";
    FolderNames.enumValuesRelations = "EnumValuesRelations";
    FolderNames.features = "Features";
    FolderNames.flows = "Flows";
    FolderNames.globalSettings = "GlobalSettings";
    FolderNames.goals = "Goals";
    FolderNames.goods = "Goods";
    FolderNames.goodsInCart = "GoodsInCart";
    FolderNames.goodsInSet = "GoodsInSet";
    FolderNames.groups = "Groups";
    FolderNames.history = "History";
    FolderNames.holidays = "Holidays";
    FolderNames.children = "Children";
    FolderNames.individualDiscounts = "IndividualDiscounts";
    FolderNames.invoiceItems = "InvoiceItems";
    FolderNames.invoices = "Invoices";
    FolderNames.itemCopyRelations = "ItemCopyRelations";
    FolderNames.journal = "Journal";
    FolderNames.knowledge = "Knowledge";
    FolderNames.layouts = "Layouts";
    FolderNames.layoutsModels = "LayoutsModels";
    FolderNames.leads = "Leads";
    FolderNames.ledger = "Ledger";
    FolderNames.mappings = "Mappings";
    FolderNames.marketing = "Marketing";
    FolderNames.marketingList = "MarketingList";
    FolderNames.marketingListSources = "MarketingListSources";
    FolderNames.models = "Models";
    FolderNames.modulePermissions = "ModulePermissions";
    FolderNames.objectTypesOptions = "ObjectTypesOptions";
    FolderNames.payments = "Payments";
    FolderNames.priceListGroups = "PriceListGroups";
    FolderNames.projectAssignments = "ProjectAssignments";
    FolderNames.projectAssignmentsPerUserProject = "ProjectAssignmentsPerUserProject";
    FolderNames.projectAssignmentsTotal = "ProjectAssignmentsTotal";
    FolderNames.projectAssignmentsTotalUserProject = "ProjectAssignmentsTotalUserProject";
    FolderNames.projectList = "ProjectList";
    FolderNames.projects = "Projects";
    FolderNames.projectUsersInCaPlan = "ProjectUsersInCaPlan";
    FolderNames.relationData = "RelationData";
    FolderNames.relations = "Relations";
    FolderNames.reports = "Reports";
    FolderNames.revisionsHistory = "RevisionsHistory";
    FolderNames.salaries = "Salaries";
    FolderNames.salePrices = "SalePrices";
    FolderNames.prices = "Prices";
    FolderNames.sqlObjects = "SqlObjects";
    FolderNames.tasks = "Tasks";
    FolderNames.recurrencePatterns = "RecurrencePatterns";
    FolderNames.teamRoles = "TeamRoles";
    FolderNames.templates = "Templates";
    FolderNames.training = "Training";
    FolderNames.users = "Users";
    FolderNames.userSettings = "UserSettings";
    FolderNames.vacation = "Vacation";
    FolderNames.webAccess2Options = "WebAccess2Options";
    FolderNames.webAccessOptions = "WebAccessOptions";
    FolderNames.workCommitments = "WorkCommitments";
    FolderNames.workflowHistory = "WorkflowHistory";
    FolderNames.workReports = "WorkReports";
    FolderNames.wrongClientVersions = "WrongClientVersions";
    FolderNames.xsltTransformations = "XsltTransformations";
    return FolderNames;
}());
exports.FolderNames = FolderNames;
